<template>
  <div class="terms-root">
    <div class="terms-container">
      <div class="terms-header">
        <h1 class="terms-title">软件服务及许可协议</h1>
        <p class="terms-subtitle">Software Service and License Agreement</p>
      </div>
      
      <div class="terms-content">
        <section class="terms-section">
          <h2 class="section-title">A. 一般</h2>
          <p>聚宝铺为商业用户提供各种电商平台软件和接口的使用服务，包括产品上架、批量处理店铺业务、AI功能等网络应用服务，商户可以通过聚宝铺有效的解决日常电商运营工作。</p>
          <p>为确保服务品质和客服隐私及保证聚宝铺产品、系统、网络、服务、服务器托管实施和其中所含材料（统称为"聚宝铺网络服务"）的完整性、安全性、可靠性和隐私性，该《软件服务及许可协议》对服务可接受的使用进行定义。聚宝铺客户（出于本政策之目的，定义为向聚宝铺购买服务的任何一方）需要遵守《软件服务及许可协议》，作为接受聚宝铺网络服务的一个条款。</p>
          <p>聚宝铺客户完全对其访问、公布、发布或以其它方式利用聚宝铺网络服务的内容、接口协议和服务负责。</p>
        </section>

        <section class="terms-section">
          <h2 class="section-title">B. 禁止的活动</h2>
          <p>任何客户或其他服务使用者通过某项服务的实行或参与下列所述任何活动都违背了聚宝铺政策（不论这些活动是实际或企图进行的，无论是直接还是间接的）。</p>
          <p>以下所列出的任何行为（每个行为，称"禁止的活动"）均构成对店步秘网络服务的滥用和对其他客户的干扰。这些行为是严禁的：</p>
          <ul class="terms-list">
            <li>广告、传送或以其他方式获取违反《软件服务及许可协议》的任何软件、程序、产品或服务，包括但不限于从事或促进用来发送未经许可的商业资讯或任何形式的通信或未经许可的大宗邮件（"SPAM"）的工具，运行 Ping 命令、洪水袭击以及拒绝服务攻击等；</li>
            <li>伪造用户或其他服务工具，这些服务是提供给聚宝铺或其他服务用户或用于从事在于保留或掩盖客服或期终端用户身份或联系任何活动或行为，包括但不限于故意泄露、删除、仿造或误传重要信息，例如：客户经营信息、订单信息、产品信息、运营数据等；</li>
            <li>从事任何其他活动，该活动：
              <ul class="sub-list">
                <li>违反法律或法规，包括但不限泄露用户数据、侵犯用户隐私、贩卖重要商业数据、色情相关产品、盗用版权、仿牌仿品、注册商标、专利、商业秘密或有其他知识产权；</li>
                <li>违反相关特许协议下聚宝铺的独有权；</li>
                <li>威胁任何网络或电脑系统的完整性或安全，包括但不限于传播病毒、特洛伊木马、蠕虫病毒、邮件炸弹、按键记录、间谍软件、广告软件或任何有害的程序或设计于负面影响电脑软件或硬件操作的类似电脑代码；</li>
                <li>目的在于任何方式危害或试图危害未成年人；</li>
                <li>试图以一种逃避税费或其他要求就使用而缴费的方式使用服务；</li>
                <li>以其他方式降低或干扰其他用户使用某项服务；</li>
                <li>违反应向第三方承担的任何法定义务，如契约义务或应尽的义务；</li>
                <li>违反国际网络或其他网络行为和使用的通常公认标准，包括但不限于修改网页、网络扫描以及未授权的系统渗透。</li>
              </ul>
            </li>
          </ul>
          <p>通过利用其他提供者的服务从事任何上述活动，但通过某个聚宝铺账户、邮件代理或其他方式通过某项服务引导活动的除外。任何客户或客户的最终用户或代表任何客户或客户的最终用户间接地违反该《软件服务及许可协议》或违反该《软件服务及许可协议》未遂的，以及任何第三方代表任何客户或客户的终端用户实际违反该《软件服务及许可协议》或违反该《软件服务及许可协议》未遂的，都将视为该客户或客户的最终用户违反该《软件服务及许可协议》。</p>
          <p>严禁转售/出售或桥接聚宝铺账户权益。如客户或其他服务使用者转售/出售或桥接聚宝铺账户，平台一经发现将立即对其服务进行下线处理，并有权追究其经济赔偿责任及法律责任。</p>
        </section>

        <section class="terms-section">
          <h2 class="section-title">C. 权利和补救措施</h2>
          <p>如果聚宝铺认定任何客户、其代表或最终用户已违反或未遵守该《软件服务及许可协议》或从事（或允许他人从事）任何禁止的活动，则聚宝铺可采取其认为适宜的措施。这可以包括以下全部或任何内容：</p>
          <ul class="terms-list">
            <li>随时暂停和/或终止该客户的服务；</li>
            <li>向该客户进行警告；</li>
            <li>向该客户进行法律程序，在要求赔偿的基础上要求赔偿因违反该《软件服务及许可协议》而产生的所有费用（包括但不限于合理的行政管理费用和法律费用）；</li>
            <li>出于保护客户的系统和网络资源的目的，拒绝来自那些支援违法活动的已知IP位置区的所有通信；</li>
            <li>对客户采取进一步法律行动；并且</li>
            <li>如果是非法行为，调查并通知相关司法部门。</li>
          </ul>
          <p>如果聚宝铺收到法院指令，要求其向某人揭露客户的身份，而该人控诉该客户滥用服务，则聚宝铺有权这样做。如果法律要求聚宝铺向警方或其他公职机关揭露客户的身份或聚宝铺拥有的关于服务使用的其他资料，则聚宝铺也有权揭露。</p>
          <p>聚宝铺将根据各人的价值，考虑所有情况和投诉。聚宝铺有权不向客户采取行动，即使投诉是针对客户违反该《软件服务及许可协议》而提出的。</p>
          <p>如可行及法律允许的话，聚宝铺保留采取技术手段来避免发生所禁止活动的权力。而且，聚宝铺保留向客户收取其进行禁止活动有关的行政管理费用的权力，包括但不限于支付确认违约者及拆除或中断其服务的过程中产生的费用，收取的金额相当于聚宝铺防止或回应该活动实际产生的费用。</p>
          <p>该《软件服务及许可协议》中没有任何内容可以限制聚宝铺对于任何被禁止活动的法律权力和补救措施。</p>
          <p>该《软件服务及许可协议》不影响适用于国际网络服务的条款与条件，这些国际网络服务由聚宝铺于聚宝铺网络范围内提供。</p>
        </section>

        <section class="terms-section">
          <h2 class="section-title">D. 密码保护</h2>
          <p>客户负责保护其个人的密码，并且对于任何授权的或未授权的使用其密码负责。没有书面的授权，客户不得透露其密码或使用或允许任何人使用聚宝铺服务来推测密码或进入其他系统或网络。如果某个网络或网络设备受到危害，聚宝铺完全有权自行决定协助进行追查并且/或在网络层面以聚宝铺认为合理的程序逐出该违约者。</p>
        </section>

        <section class="terms-section">
          <h2 class="section-title">E. 《软件服务及许可协议》的执行性及修改</h2>
          <p>如果该《软件服务及许可协议》的任何条款或其任何部分出于任何原因被宣布无效，则有抵触的词句应视为已被删除，而其他条款应继续保持完全有效。</p>
          <p>聚宝铺保留随时更新该《软件服务及许可协议》而无需通知的权力，更新自公布在网站 https://jubaopu.top 上起生效。</p>
        </section>

        <section class="terms-section">
          <h2 class="section-title">F. 适用法律和管辖许可权</h2>
          <p>本政策受中华人民共和国法律的管辖，双方完全服从中华人民共和国法庭的管辖。</p>
        </section>
      </div>

      <div class="terms-footer">
        <button class="back-btn" @click="goBack">返回</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

onMounted(() => {
  document.title = '聚宝铺-软件服务及许可协议'
})

function goBack() {
  router.go(-1)
}
</script>

<style scoped>
.terms-root {
  min-height: 100vh;
  background: #f7faff;
  padding: 20px;
  box-sizing: border-box;
}

.terms-container {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 24px #4ba3fa22;
  overflow: hidden;
}

.terms-header {
  background: linear-gradient(135deg, #0875e2 0%, #2979ff 100%);
  color: #fff;
  padding: 40px;
  text-align: center;
}

.terms-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0 0 10px 0;
  letter-spacing: 2px;
}

.terms-subtitle {
  font-size: 1.2rem;
  margin: 0;
  opacity: 0.9;
  font-weight: 300;
}

.terms-content {
  padding: 40px;
  line-height: 1.8;
  color: #333;
}

.terms-section {
  margin-bottom: 40px;
}

.terms-section:last-child {
  margin-bottom: 0;
}

.section-title {
  color: #2979ff;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #e3f2fd;
}

.terms-content p {
  margin: 0 0 16px 0;
  text-align: justify;
}

.terms-content p:last-child {
  margin-bottom: 0;
}

.terms-list {
  margin: 16px 0;
  padding-left: 20px;
}

.terms-list li {
  margin-bottom: 12px;
  text-align: justify;
}

.sub-list {
  margin: 12px 0 0 20px;
  padding-left: 20px;
}

.sub-list li {
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.terms-footer {
  padding: 30px 40px;
  text-align: center;
  border-top: 1px solid #e3f2fd;
  background: #fafbfc;
}

.back-btn {
  background: linear-gradient(90deg, #4ba3fa 0%, #2979ff 100%);
  color: #fff;
  border: none;
  border-radius: 16px;
  padding: 12px 32px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px #4ba3fa33;
}

.back-btn:hover {
  background: linear-gradient(90deg, #2979ff 0%, #4ba3fa 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px #4ba3fa44;
}

@media (max-width: 768px) {
  .terms-root {
    padding: 10px;
  }
  
  .terms-header {
    padding: 30px 20px;
  }
  
  .terms-title {
    font-size: 2rem;
  }
  
  .terms-subtitle {
    font-size: 1rem;
  }
  
  .terms-content {
    padding: 30px 20px;
  }
  
  .terms-footer {
    padding: 20px;
  }
  
  .back-btn {
    width: 100%;
    max-width: 300px;
    padding: 14px 32px;
  }
}

@media (max-width: 480px) {
  .terms-header {
    padding: 25px 15px;
  }
  
  .terms-title {
    font-size: 1.8rem;
  }
  
  .terms-content {
    padding: 25px 15px;
  }
  
  .section-title {
    font-size: 1.3rem;
  }
}
</style>
